const Title = ({ children, size = 'S' | 'M' | 'L' | 'XL', headingLevel = 1 | 2 | 3 | 4 | 5 | 6 }) => {
    const headingLevels = {
        1: 'h1',
        2: 'h2',
        3: 'h3',
        4: 'h4',
        5: 'h5',
        6: 'h6',
    };

    const fontSizes = {
        S: '36px',
        M: '56px',
        L: 'clamp(45px, 6vw, 72px)',
        XL: 'clamp(50px, 13vw, 115px)',
    };

    const HeadingTag = headingLevels[headingLevel] || 'h1';

    return (
        <HeadingTag className="title" style={{ fontSize: fontSizes[size] }}>
            {children}
        </HeadingTag>
    );
};

export default Title;